import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.5.2_8d0ef075f0b6089edd36efcec896d152/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/apps/main-site/modern/src/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}